
// import AssoCricle from "../assets/AssoCricle.jpeg";
// import NirmalKumar from "../assets/Nirmal_Kumar.jpg";
// import Amitabh_img from "../assets/Amitabh_img.jpg"
// import sanjay_img from "../assets/sanjay_img.jpg"
// import saurabh_img from "../assets/saurabh_img.jpg"

// const leaders = [
//   {
//     name: "Nirmal Kumar Minda",
//     firm: "",
//     title: "President, ASSOCHAM",
//     image: NirmalKumar,
//     linkedin: "#",
//   },
//   {
//     name: "Amitabh Chaudhry",
//     firm: "",
//     title: "Senior Vice President, ASSOCHAM",
//     image: Amitabh_img,
//     linkedin: "#",
//   },
//   {
//     name: "Sanjay Nayar",
//     firm: "",
//     title: "Immediate Past President, ASSOCHAM",
//     image: sanjay_img,
//     linkedin: "#",
//   },
//   {
//     name: "Saurabh Sanyal",
//     firm: "",
//     title: "Secretary General, ASSOCHAM",
//     image: saurabh_img,
//     linkedin: "#",
//   },
// ];

// function ArrowIcon() {
//   return (
//     <svg viewBox="0 0 8 12" className="h-2.5 w-2 flex-shrink-0 fill-[#f47b20]" aria-hidden="true">
//       <polygon points="0,0 8,6 0,12" />
//     </svg>
//   );
// }

// /* ---------------- BREADCRUMB ---------------- */
// function Breadcrumb() {
//   return (
//     <nav
//       aria-label="Breadcrumb"
//       className="breadcrumb-in absolute left-4 top-4 z-20 sm:left-8 sm:top-6"
//     >
//       <ol className="flex items-center gap-2 rounded-full border border-white/25 bg-white/15 px-4 py-2 text-xs font-bold uppercase tracking-wide text-white shadow-lg backdrop-blur-md sm:text-sm">
//         <li>
//           <a href="#" className="inline-flex items-center gap-1.5 transition-colors duration-300 hover:text-[#F3ECE2]">
//             <svg viewBox="0 0 24 24" className="h-4 w-4" fill="none" stroke="currentColor" strokeWidth={2.2} strokeLinecap="round" strokeLinejoin="round">
//               <path d="M3 10.5 12 3l9 7.5" />
//               <path d="M5 10v10h14V10" />
//               <path d="M9 20v-6h6v6" />
//             </svg>
//             Home
//           </a>
//         </li>
//         <li className="text-white/60">&rsaquo;</li>
//         <li>
//           <a href="#" className="transition-colors duration-300 hover:text-[#F3ECE2]">About</a>
//         </li>
//         <li className="text-white/60">&rsaquo;</li>
//         <li className="rounded-full bg-white px-3 py-1 text-[#DA2128] shadow-sm">Leadership</li>
//       </ol>
//     </nav>
//   );
// }

// function ProfileCard({ leader }) {
//   return (
//     <div
//       className="relative flex w-full overflow-hidden bg-[#f3ece2] border-4 border-[#dddfe1]"
//       style={{
//         minHeight: "320px",
//         clipPath: "polygon(0% 0%, calc(95% - 103px) -11%, 96% 64px, 96% calc(103% + 0px), calc(80% - 26px) 102%, -1% 101%)",
//         borderRadius: "14px",
//       }}
//     >
//       {/* ── LEFT ZONE: AssoCricle + LARGE Leader Photo ── */}
//       <div className="relative flex-shrink-0" style={{ width: "220px", minHeight: "320px" }}>

//         {/* AssoCricle Background Strip */}
//         <img
//           src={AssoCricle}
//           alt=""
//           aria-hidden="true"
//           draggable={false}
//           className="absolute inset-0 h-full w-full object-cover object-center"
//         />

//         {/* Leader Photo — Now Much Larger */}
//         <img
//           src={leader.image}
//           alt={leader.name}
//           draggable={false}
//           className="absolute bottom-0 left-[-30px] !min-w-[140%] h-[88%] select-none object-contain object-bottom z-10"
//         />
//       </div>

//       {/* ── RIGHT ZONE: text + buttons ── */}
//       <div className="flex flex-1 flex-col justify-center px-6 py-6">

//         {/* Name */}
//         <h2 className="text-xl font-extrabold leading-tight text-[#0a2c5c] sm:text-2xl">
//           {leader.name}
//         </h2>

//         {/* Firm */}
//         <p className="mt-2 text-base font-semibold leading-snug text-[#0a2c5c]">
//           {leader.firm}
//         </p>

//         {/* Title */}
//         <p className="mt-1 whitespace-pre-line text-base font-semibold leading-snug text-[#f47b20]">
//           {leader.title}
//         </p>

//         {/* Buttons */}
//         <div className="mt-6 flex flex-wrap gap-3">
//           <a
//             href="#"
//             className="inline-flex items-center gap-2 border-2 border-[#f47b20] bg-transparent px-5 py-2.5 text-sm font-bold text-[#0a2c5c] transition-colors hover:bg-[#f47b20] hover:text-white"
//           >
//             <span>Read bio</span>
//             <ArrowIcon />
//           </a>
//           <a
//             href={leader.linkedin}
//             className="inline-flex items-center gap-2 border-2 border-[#f47b20] bg-transparent px-5 py-2.5 text-sm font-bold text-[#0a2c5c] transition-colors hover:bg-[#f47b20] hover:text-white"
//           >
//             <span>LinkedIn</span>
//             <ArrowIcon />
//           </a>
//         </div>
//       </div>
//     </div>
//   );
// }

// export default function LeaderShip() {
//   return (
//     <>
//       {/* Added Header */}
//      <header className="relative overflow-hidden bg-gradient-to-r from-[#DA2128] via-[#E04A1A] to-[#EE8202] py-16 text-center text-white sm:py-20">
//   <Breadcrumb />
//   <span className="floating absolute -left-10 top-8 h-40 w-40 rounded-full bg-white/10" />
//   <span className="floating-slow absolute -right-8 bottom-0 h-52 w-52 rounded-full bg-white/10" />
//   <span className="floating absolute left-1/3 top-2 h-14 w-14 rounded-full bg-white/10" />
  
//   <div className="hero-in relative mx-auto max-w-3xl px-4">
//     <p className="text-xs font-bold uppercase tracking-[0.35em] text-white/80">
//       Meet our visionary leaders
//     </p>
//     <h1 className="mt-3 text-4xl font-extrabold uppercase tracking-tight sm:text-5xl">
//       ASSOCHAM Leadership
//     </h1>
//     <div className="mx-auto mt-5 h-1 w-24 rounded-full bg-white/70" />
//     <p className="mx-auto mt-5 max-w-xl text-sm text-white/85 sm:text-base">
//       Dynamic leaders guiding ASSOCHAM with strategic vision, industry expertise, 
//       and a steadfast commitment to driving India's economic growth and policy excellence.
//     </p>
//   </div>
// </header>

//       {/* Original Content (kept unchanged) */}
//       <div className="min-h-screen w-full bg-white px-6 py-16">
//         <div className="mx-auto grid max-w-[1100px] grid-cols-1 gap-6 md:grid-cols-2">
//           {leaders.map((leader, index) => (
//             <ProfileCard key={index} leader={leader} />
//           ))}
//         </div>
//       </div>
//     </>
//   );
// } 
  
 
  
// new new code 






import { useState, useEffect } from "react";
import AssoCricle from "../assets/AssoCricle.jpeg";
import NirmalKumar from "../assets/Nirmal_Kumar.jpg";
import Amitabh_img from "../assets/Amitabh_img.jpg"
import sanjay_img from "../assets/sanjay_img.jpg"
import saurabh_img from "../assets/saurabh_img.jpg"

const leaders = [
  {
    name: "Nirmal Kumar Minda",
    firm: "",
    title: "President, ASSOCHAM",
    image: NirmalKumar,
    linkedin: "https://www.linkedin.com/in/nirmal-k-minda-74b8a4295",
    bio: `Mr. Nirmal Kumar Minda is a dynamic leader and a pioneer in Auto component Industry who has made significant contribution in shaping auto industry supply chain in last five decades. He played a pivotal role in transforming Uno Minda Group from a small manufacturing firm to global conglomerate having revenue of around USD 2.35 Bn with 78 Manufacturing plants in 6 countries having diversified product portfolio of 28 product lines. He ensured that innovation is right at the center of the group, change easily adopted and future thoroughly anticipated. With his customer centricity and people first approach he has made a distinguished place for himself in the industry.

He also played an instrumental role in self reliance of Auto component industry by facilitating localisation of various components either through in house development at Uno Minda R&D centres or through bringing foreign technology into India through foreign technology joint venture partner.

He has also served as President of ACMA (2017-2018), Vice-President (2016-2017) and the Chairman of ACMA, Northern region for three consecutive years. As ACMA President, he changed the face of ACMA bringing drastic changes in structure of the organisation, government advocacy, skilling, training, regulations and research, made it the formidable organization that it is today. Beyond ACMA, he has held leadership positions in CII Haryana State Council and CII Northern region in the past. Recently in Oct 2025, he has been elected as ASSOCHAM President to contribute to India's growth initiatives.

Mr. Minda has been felicitated with several awards and accolades for his professional and social achievements. He had been bestowed with EY Entrepreneur of the Year (Medium Category) as well as Best CEO by Business Today in the year 2019. He was also honoured with the Hurun India "Self-made Entrepreneur Award" in 2023. In 2024, he was honored as one of India's Most Trusted Leaders by the Great Place to Work® Institute (India). He was also bestowed 'Haryana Ratna Award' for his outstanding professional and social achievements. Mr Minda has been also honoured as one of Fortune India's Best CEOs 2025 for championing innovation, people-first leadership & inclusive growth.

A firm believer in giving back to the society, Nirmal Minda along with his wife Smt Suman Minda founded Samarth-Jyoti, a CSR welfare program spearheaded by Suman Nirmal Minda Charitable Foundation. For over two-and-a-half decades, the foundation has contributed to the holistic development of underprivileged communities. The Foundation today runs two senior secondary schools with over 1500 students each, a 100 bedded multi-speciality hospital and more than 18 Samarth Jyoti centres. The foundation touches more than 15,000 people from 18 villages across seven states in India. His endeavour is to enable and empower the underprivileged section of the society through capacity building, education and other community volunteering programmes leading towards sustainable development.`,
  },
  {
    name: "Amitabh Chaudhry",
    firm: "",
    title: "Senior Vice President, ASSOCHAM",
    image: Amitabh_img,
    linkedin: "https://www.linkedin.com/in/amitabh-chaudhry-7b560b1",
    bio: `Amitabh Chaudhry has had a long and distinguished career spanning 38 years across various sectors in India and abroad. Amitabh is the MD&CEO of Axis Bank since 1st January 2019. He leads Axis Group, a financial conglomerate, with a world class leadership team and a clearly defined vision of fulfilling the aspirations of a new, resurgent India. Over the last six years, Axis Bank has turned in industry leading performance on growth, profitability, and sustainability, with a deep focus on digital, customer experience, Bharat banking, risk and governance.

Before joining Axis Bank, Amitabh was the MD & CEO of HDFC Life. During his nine years stint which started in 2010, he built one of the most valued life insurance franchises in the country.

Amitabh started his career with Bank of America in 1987, where he donned diverse roles like head of technology investment banking for Asia, regional finance head for wholesale bank, CFO (India) and various senior roles in the wholesale banking side of the businesses. After 16 years of banking, he switched careers and became part of the founding leadership team at Infosys BPM in 2003, building a successful process outsourcing business across seven countries. Apart from the BPO business he also ran the validation unit for Infosys for sometime.

He has also served as Director on the board of several reputed organizations and has received numerous awards and recognitions. He chairs the Boards of Axis Capital Limited, Axis Finance Limited and Axis Asset Management Company Limited.

Amitabh is an Engineer from Birla Institute of Technology and Science, Pilani, and holds a postgraduate degree in Business Management from IIM, Ahmedabad.`,
  },
  {
    name: "Sanjay Nayar",
    firm: "",
    title: "Immediate Past President, ASSOCHAM",
    image: sanjay_img,
    linkedin: "https://www.linkedin.com/in/sanjay-nayar-bb505136/",
    bio: `Sanjay Nayar is a senior finance professional in the Indian private investing landscape and has over three decades of experience in the Global financial markets. Presently, he is the Founder and Chairman of Sorin Investment Fund, an early-stage technology fund founded in December 2022.

Kohlberg Kravis Roberts (2009 to April 2023): Sanjay founded and established KKR India operations in 2009 after leaving Citigroup. At KKR, Sanjay led investments of around USD 14 Billion in Private Equity, Real Estate, Infrastructure and Credit with Private equity being the largest at approximate USD 10 billion valuation. After 14 years as CEO, Chairman and Advisor, Sanjay retired on 01 April 2023. At KKR, Sanjay developed global experience interacting with global corporations, sovereign wealth funds and global institutional investors leading the investment in India. He has also previously served on the Asian investment and portfolio management committees of KKR, and has been on the boards of various KKR portfolio companies and serves as Chairman of Avendus Capital.

Citigroup (1985-2009): Prior to KKR, Sanjay worked across senior leadership positions in Citibank / Citigroup for 25 years in India, UK, and USA. He was also CEO of Citigroup's Indian and South Asian operations and was a member of Citigroup's Global Management Committee and Asia Executive Operating Committee. At Citibank, Sanjay joined from IIM(A) directly in 1985, where he served many corporate and investment banking roles in India, before being promoted to lead equities in the UK in 1992 and then to Citibank New York in 1997, leading Citigroup in Markets, Fixed Income, Sales, and Trading. He finally returned as CEO Citigroup India & South Asia in 2001 and led the Citi franchise in India to become the largest foreign bank in profits, with main experiences including large project financing and the launch of SME banking and consumer finance. During his tenure he developed top tier corporate and sovereign relationships both for India and the South Asian countries he oversaw.

In addition, he also serves as a Non-Executive Director at the new-age E-commerce company NYKAA, assisting in a non-executive capacity in mergers and acquisitions activity as well as overseeing its expansion in the UAE, UK, and the USA.

Marquee affiliations: Recently appointed as a non-official member for the Board of Trade, Government of India, representing the private sector (a key advisory body to the commerce and industry ministry). Member of the Board of US-India Strategic Partnership Forum (USISPF), Governing Board of Indian School of Business (ISB), member of Advisory Board of Habitat for Humanity, Chairman of Grameen Impact Investments India (GIII), and Founder – Board Member of Centre for Social and Economic Progress (CSEP). Previously served as: Member of NISM (SEBI's National Institute of Securities Markets), Member of the first AIF committee led by Narayan Murthy under the SEBI, President of the IVCA, and served on the Board of EMPEA – Washington DC from 2015 to 2019.`,
  },
  {
    name: "Saurabh Sanyal",
    firm: "",
    title: "Secretary General, ASSOCHAM",
    image: saurabh_img,
    linkedin: "https://www.linkedin.com/in/saurabh-sanyal-958a4035",
    bio: `A seasoned veteran of the Indian Army (Corps of Engineers) with 42 years of leadership experience across international and Domestic Project Management, Corporate Governance, Policy Advocacy, and Strategic Operations. Former CEO & Secretary General of PHD Chamber of Commerce, he has led large organisations, managed P&L, driven government and industry collaborations, and executed multi-million-dollar infrastructure projects across India, Africa, and South Asia.

He has served on boards and JVs, worked closely with Central Ministries, Global Chambers, Embassies, and Multilateral Stakeholders, and steered CSR, MSME development, Policy formulation, and capacity building initiatives. Decorated twice with the COAS Commendation and honoured internationally for his contributions, he brings deep expertise in Risk Management, Governance, Stakeholder Engagement, Logistics, and Strategic Planning. With strong credentials in Engineering, Management, Defence Operations, and Corporate Leadership, he is well-positioned to serve, offering integrity, strategic insight, and broad sectoral exposure.

Currently serving as the Secretary General of the 105 year old Apex National Chamber of Commerce and Industries, ASSOCHAM since 28th January 2026.

An avid sportsman and Golfer.`,
  },
];

function ArrowIcon() {
  return (
    <svg viewBox="0 0 8 12" className="h-2.5 w-2 flex-shrink-0 fill-[#f47b20]" aria-hidden="true">
      <polygon points="0,0 8,6 0,12" />
    </svg>
  );
}

/* ---------------- BREADCRUMB ---------------- */
function Breadcrumb() {
  return (
    <nav
      aria-label="Breadcrumb"
      className="breadcrumb-in absolute left-4 top-4 z-20 sm:left-8 sm:top-6"
    >
      <ol className="flex items-center gap-2 rounded-full border border-white/25 bg-white/15 px-4 py-2 text-xs font-bold uppercase tracking-wide text-white shadow-lg backdrop-blur-md sm:text-sm">
        <li>
          <a href="#" className="inline-flex items-center gap-1.5 transition-colors duration-300 hover:text-[#F3ECE2]">
            <svg viewBox="0 0 24 24" className="h-4 w-4" fill="none" stroke="currentColor" strokeWidth={2.2} strokeLinecap="round" strokeLinejoin="round">
              <path d="M3 10.5 12 3l9 7.5" />
              <path d="M5 10v10h14V10" />
              <path d="M9 20v-6h6v6" />
            </svg>
            Home
          </a>
        </li>
        <li className="text-white/60">&rsaquo;</li>
        <li>
          <a href="#" className="transition-colors duration-300 hover:text-[#F3ECE2]">About</a>
        </li>
        <li className="text-white/60">&rsaquo;</li>
        <li className="rounded-full bg-white px-3 py-1 text-[#DA2128] shadow-sm">Leadership</li>
      </ol>
    </nav>
  );
}

/* ---------------- BIO MODAL ---------------- */
function BioModal({ leader, onClose }) {
  useEffect(() => {
    if (!leader) return;

    const handleKeyDown = (e) => {
      if (e.key === "Escape") onClose();
    };

    document.addEventListener("keydown", handleKeyDown);
    const previousOverflow = document.body.style.overflow;
    document.body.style.overflow = "hidden";

    return () => {
      document.removeEventListener("keydown", handleKeyDown);
      document.body.style.overflow = previousOverflow;
    };
  }, [leader, onClose]);

  if (!leader) return null;

  return (
    <div
      className="fixed inset-0 z-[9999] flex items-center justify-center bg-[#0a2c5c]/70 px-4 py-8 backdrop-blur-sm"
      onClick={onClose}
      role="dialog"
      aria-modal="true"
      aria-labelledby="bio-modal-title"
    >
      <div
        className="relative flex max-h-[85vh] w-full max-w-2xl flex-col overflow-hidden rounded-2xl border-4 border-[#dddfe1] bg-[#f3ece2] shadow-2xl"
        onClick={(e) => e.stopPropagation()}
      >
        {/* Header */}
        <div className="flex items-start justify-between gap-4 border-b-2 border-[#f47b20]/30 bg-[#f3ece2] px-6 py-5 sm:px-8">
          <div className="flex items-center gap-4">
            <img
              src={leader.image}
              alt={leader.name}
              className="h-14 w-14 flex-shrink-0 rounded-full border-2 border-[#f47b20] object-cover object-top"
            />
            <div>
              <h3 id="bio-modal-title" className="text-lg font-extrabold leading-tight text-[#0a2c5c] sm:text-xl">
                {leader.name}
              </h3>
              {leader.title && (
                <p className="mt-1 text-sm font-semibold leading-snug text-[#f47b20]">{leader.title}</p>
              )}
            </div>
          </div>
          <button
            type="button"
            onClick={onClose}
            aria-label="Close bio"
            className="flex h-9 w-9 flex-shrink-0 items-center justify-center rounded-full border-2 border-[#f47b20] text-[#0a2c5c] transition-colors hover:bg-[#f47b20] hover:text-white"
          >
            <svg viewBox="0 0 24 24" className="h-4 w-4" fill="none" stroke="currentColor" strokeWidth={2.5} strokeLinecap="round">
              <path d="M6 6l12 12M18 6L6 18" />
            </svg>
          </button>
        </div>

        {/* Body */}
        <div className="space-y-4 overflow-y-auto px-6 py-6 text-sm leading-relaxed text-[#0a2c5c]/90 sm:px-8 sm:text-base">
          {leader.bio.split("\n\n").map((paragraph, i) => (
            <p key={i}>{paragraph.trim()}</p>
          ))}
        </div>

        {/* Footer */}
        {leader.linkedin && leader.linkedin !== "#" && (
          <div className="border-t-2 border-[#f47b20]/30 bg-[#f3ece2] px-6 py-4 sm:px-8">
            <a
              href={leader.linkedin}
              target="_blank"
              rel="noopener noreferrer"
              className="inline-flex items-center gap-2 border-2 border-[#f47b20] bg-transparent px-5 py-2.5 text-sm font-bold text-[#0a2c5c] transition-colors hover:bg-[#f47b20] hover:text-white"
            >
              <span>View LinkedIn</span>
              <ArrowIcon />
            </a>
          </div>
        )}
      </div>
    </div>
  );
}

/* ---------------- PROFILE CARD ---------------- */
function ProfileCard({ leader, onReadBio }) {
  return (
    <div
      className="relative flex w-full overflow-hidden bg-[#f3ece2] border-4 border-[#dddfe1]"
      style={{
        minHeight: "320px",
        clipPath: "polygon(0% 0%, calc(95% - 103px) -11%, 96% 64px, 96% calc(103% + 0px), calc(80% - 26px) 102%, -1% 101%)",
        borderRadius: "14px",
      }}
    >
      {/* ── LEFT ZONE: AssoCricle + LARGE Leader Photo ── */}
      <div className="relative flex-shrink-0" style={{ width: "220px", minHeight: "320px" }}>

        {/* AssoCricle Background Strip */}
        <img
          src={AssoCricle}
          alt=""
          aria-hidden="true"
          draggable={false}
          className="absolute inset-0 h-full w-full object-cover object-center"
        />

        {/* Leader Photo — Now Much Larger */}
        <img
          src={leader.image}
          alt={leader.name}
          draggable={false}
          className="absolute bottom-0 left-[-30px] !min-w-[140%] h-[88%] select-none object-contain object-bottom z-10"
        />
      </div>

      {/* ── RIGHT ZONE: text + buttons ── */}
      <div className="flex flex-1 flex-col justify-center px-6 py-6">

        {/* Name */}
        <h2 className="text-xl font-extrabold leading-tight text-[#0a2c5c] sm:text-2xl">
          {leader.name}
        </h2>

        {/* Firm */}
        <p className="mt-2 text-base font-semibold leading-snug text-[#0a2c5c]">
          {leader.firm}
        </p>

        {/* Title */}
        <p className="mt-1 whitespace-pre-line text-base font-semibold leading-snug text-[#f47b20]">
          {leader.title}
        </p>

        {/* Buttons */}
        <div className="mt-6 flex flex-wrap gap-3">
          <button
            type="button"
            onClick={onReadBio}
            className="inline-flex items-center gap-2 border-2 border-[#f47b20] bg-transparent px-5 py-2.5 text-sm font-bold text-[#0a2c5c] transition-colors hover:bg-[#f47b20] hover:text-white"
          >
            <span>Read bio</span>
            <ArrowIcon />
          </button>
          <a
            href={leader.linkedin}
            target="_blank"
            rel="noopener noreferrer"
            className="inline-flex items-center gap-2 border-2 border-[#f47b20] bg-transparent px-5 py-2.5 text-sm font-bold text-[#0a2c5c] transition-colors hover:bg-[#f47b20] hover:text-white"
          >
            <span>LinkedIn</span>
            <ArrowIcon />
          </a>
        </div>
      </div>
    </div>
  );
}

export default function LeaderShip() {
  const [selectedLeader, setSelectedLeader] = useState(null);

  return (
    <>
      {/* Added Header */}
     <header className="relative overflow-hidden bg-gradient-to-r from-[#DA2128] via-[#E04A1A] to-[#EE8202] py-16 text-center text-white sm:py-20">
  <Breadcrumb />
  <span className="floating absolute -left-10 top-8 h-40 w-40 rounded-full bg-white/10" />
  <span className="floating-slow absolute -right-8 bottom-0 h-52 w-52 rounded-full bg-white/10" />
  <span className="floating absolute left-1/3 top-2 h-14 w-14 rounded-full bg-white/10" />
  
  <div className="hero-in relative mx-auto max-w-3xl px-4">
    <p className="text-xs font-bold uppercase tracking-[0.35em] text-white/80">
      Meet our visionary leaders
    </p>
    <h1 className="mt-3 text-4xl font-extrabold uppercase tracking-tight sm:text-5xl">
      ASSOCHAM Leadership
    </h1>
    <div className="mx-auto mt-5 h-1 w-24 rounded-full bg-white/70" />
    <p className="mx-auto mt-5 max-w-xl text-sm text-white/85 sm:text-base">
      Dynamic leaders guiding ASSOCHAM with strategic vision, industry expertise, 
      and a steadfast commitment to driving India's economic growth and policy excellence.
    </p>
  </div>
</header>

      {/* Original Content (kept unchanged) */}
      <div className="min-h-screen w-full bg-white px-6 py-16">
        <div className="mx-auto grid max-w-[1100px] grid-cols-1 gap-6 md:grid-cols-2">
          {leaders.map((leader, index) => (
            <ProfileCard
              key={index}
              leader={leader}
              onReadBio={() => setSelectedLeader(leader)}
            />
          ))}
        </div>
      </div>

      <BioModal leader={selectedLeader} onClose={() => setSelectedLeader(null)} />
    </>
  );
}